import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import omit from 'lodash/omit';
const DEVICE_SIZES = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
export const Row = /*#__PURE__*/ React.forwardRef(({ className, noGutters = false, componentClass: Component = 'div', ...props }, ref)=>{
    const classes = [];
    DEVICE_SIZES.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        let cols;
        if (propValue !== null && propValue !== undefined && typeof propValue === 'object') {
            ({ cols } = propValue);
        } else {
            cols = propValue;
        }
        const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';
        if (cols !== null && cols !== undefined) classes.push(`row-cols${infix}-${cols}`);
    });
    const propsToPass = useMemo(()=>omit(props, ...DEVICE_SIZES), [
        props
    ]);
    return /*#__PURE__*/ _jsx(Component, {
        ref: ref,
        ...propsToPass,
        className: classNames(className, 'row', noGutters && 'no-gutters', ...classes)
    });
});
Row.displayName = 'Row';
export default Row;
